import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (21.921 / 24);
  const localHeight = size * (22 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 21.921 22">
      <path
        d="M10.014,21.858a.755.755,0,0,1-.3-.779l.548-2.435H.755A.755.755,0,0,1,0,17.889V.755A.755.755,0,0,1,.755,0h14.18a.755.755,0,0,1,.755.755v9.367l2.463-3.431a.755.755,0,0,1,1.054-.173l2.4,1.722a.755.755,0,0,1,.173,1.054L14.3,19.719a.747.747,0,0,1-.221.2L10.847,21.89a.755.755,0,0,1-.833-.032Zm1.973-3.986-.406,1.8,1.579-.961,6.953-9.687-1.173-.842ZM1.51,17.134h9.147l.013-.019,3.517-4.9a.764.764,0,0,1-.007-.1V1.51H1.51ZM4.3,13.87a.708.708,0,1,1,0-1.416h7.09a.708.708,0,0,1,0,1.416Zm0-3.939a.708.708,0,0,1,0-1.416h7.09a.708.708,0,0,1,0,1.416Zm0-3.939a.708.708,0,1,1,0-1.416h7.09a.708.708,0,0,1,0,1.416Z"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
